module.exports = __webpack_public_path__ + "static/media/jenkins.a422d22b.svg";